module.exports = __webpack_public_path__ + "img/pa.68029990.svg";